import LayoutCenter from "../UserInterface/LayoutCenter";
import Description from "../UserInterface/Description";
import gold from "../../../public/static/images/svg/Ciritical_Gold.svg";
import silver from "../../../public/static/images/svg/Ciritical_Silver.svg";
import platinum from "../../../public/static/images/svg/Ciritical_Platinum.svg";

export const CriticalChoice = () => {
  const choices = [
    { type: "SILVER", image: silver, price: "Rp20.000.000" },
    { type: "GOLD", image: gold, price: "Rp50.000.000" },
    { type: "PLATINUM", image: platinum, price: "Rp100.000.000" }
  ];
  return (
    <LayoutCenter
      column
      widthLayout="100vw"
      width="100%"
      backgroundColor="#F4F4F4"
      marginMobile="24px 16px"
      padding='10px 0px 30px 0px'
    >
      <Description
        text="Terdapat 3 pilihan Plan CriticaLifeCOVER dengan jumlah santunan sebagai berikut:"
        maxWidth="456px"
        fontWeight="bold"
        fontSize="24px"
        font="Roboto"
        alignMobile="left"
        fontMobile="16px"
        marginMobile="16px 25px"
      ></Description>
      <div className="blocks-container">
        {choices.map((data, key) => {
          return (
            <div key={key} className="blocks">
              <div style={{ display: "flex" }}>
                <img src={data.image}></img>
                <h4>{data.type}</h4>
              </div>
              <h3 style={{ marginTop: "36px" }}>{data.price}</h3>
            </div>
          );
        })}
      </div>
      <style jsx>{`
        .blocks {
          background-color: #ffffff;
          border-radius: 8px;
          box-shadow: 0 2px 4px 0 #c8c8c8;
          padding: 24px 70px;
          margin: 16px 10px;
        }
        .blocks-container {
          display: flex;
        }

        @media only screen and (max-width: 830px) {
          .blocks-container {
            flex-direction: column;
          }
        }
      `}</style>
    </LayoutCenter>
  );
};
